export const portalPaths = {
  root: "/",
  login: "/login",
  forgotPassword: "/forgot-password",
  signup: "/signup",
  resetPassword: "/reset-password",
  dashboard: "/dashboard",
  teamMemberHome: "/dashboard",
  profile: "/profile",
  assistant: "/assistant",
  assistantThread: (id: string) => `/assistant/${id}`,
  requests: "/requests",
  request: (id: string) => `/requests/${id}`,
  newRequest: "/requests/new",
  newRequestOption: (id: string) => `/requests/${id}/options/new`,
  itineraries: "/itineraries",
  bookings: "/bookings",
  itinerary: (id: string) => `/itineraries/${id}`,
  editItinerary: (id: string) => `/itineraries/${id}/edit`,
  newItinerary: "/requests/new",
} as const;

/** Returns domain-independent routes for the portal application. */
export const getPortalPaths = () => portalPaths;

/** Returns the appropriate portal landing page for an authenticated actor. */
export const getPortalLandingPath = (actorType: "tenant_user" | "agency_user") =>
  actorType === "tenant_user" ? portalPaths.teamMemberHome : portalPaths.dashboard;

/** Determines whether a pathname is one of the supported portal routes. */
export const isAgentPortalPath = (pathname: string): boolean => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return true;
  if (
    ["login", "signup", "forgot-password", "reset-password", "dashboard", "profile", "bookings", "new-itinerary"].includes(
      segments[0],
    )
  ) {
    return segments.length === 1;
  }
  if (segments[0] === "assistant") return segments.length <= 2;
  if (segments[0] === "requests") {
    return segments.length === 1 || segments.length === 2 || (segments.length === 4 && segments[2] === "options" && segments[3] === "new");
  }
  return segments[0] === "itineraries" && (segments.length === 1 || segments.length === 2 || (segments.length === 3 && segments[2] === "edit"));
};
